import { useAuth, usePageAccess } from 'hooks'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { PAGE_DASHBOARD, PAGE_LOGIN, PAGE_NOT_FOUND } from 'utils/constants'

type Props = {
  checkEditAccess?: boolean
}

const PageAccessWrapper = ({ checkEditAccess = false }: Props) => {
  const { isAuthenticated } = useAuth()
  const { isEditor, page } = usePageAccess()
  const { pathname } = useLocation()

  // if not authenticated
  if (!isAuthenticated) {
    return <Navigate replace to={PAGE_LOGIN.path} />
  }

  // if dont have Edit Access
  if (checkEditAccess && page && !isEditor) {
    return <Navigate replace to={PAGE_NOT_FOUND.path} />
  }

  // valid access
  if (page || pathname === PAGE_DASHBOARD.path) {
    return <Outlet />
  }

  return <Navigate replace to={PAGE_NOT_FOUND.path} />
}

export default PageAccessWrapper
